import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_REORDER_COL_DEF,
  GRID_TREE_DATA_GROUPING_FIELD,
} from '@mui/x-data-grid-pro';
import type { TableDensity } from '@tempo-io/roadmap-dto';

export const DEFAULT_PINNED_COLUMNS = {
  left: [GRID_REORDER_COL_DEF.field, GRID_CHECKBOX_SELECTION_FIELD, GRID_TREE_DATA_GROUPING_FIELD],
  right: [] as string[],
};

export type OnDensityChange = (density: TableDensity) => void;

export const DENSITY_ROW_HEIGHT: Record<TableDensity, number> = {
  compact: 28,
  standard: 35,
  comfortable: 44,
};

export const DENSITY_HEADER_HEIGHT: Record<TableDensity, number> = {
  compact: 32,
  standard: 40,
  comfortable: 52,
};

export const VALID_V2_FIELD_IDS: ReadonlySet<string> = new Set([
  'createdAt',
  'createdBy',
  'customFields',
  'dependencies',
  'description',
  'doneDateTime',
  'estimationId',
  'estimationSchema',
  'externalCreatedAt',
  'externalKey',
  'externalLink',
  'id',
  'itemStatusId',
  'itemTypeId',
  'loopId',
  'name',
  'parentId',
  'plannedFinishDateTime',
  'plannedStartDateTime',
  'priority',
  'schedulingType',
  'schedules',
  'deadlineDateTime',
  'earliestStartDateTime',
  'teamId',
  'timeSpentSeconds',
  'updatedAt',
  'updatedBy',
]);
